module.exports = __webpack_public_path__ + "img/onlineCall-img1.3e128b6a.png";